// extracted by mini-css-extract-plugin
export default {"page":"styles-module__page__ufo99vR","subnav":"styles-module__subnav__xN6OX9m"};